module.exports = __webpack_public_path__ + "assets/ic_badge_07.db41a917.svg";